import { createFileRoute } from '@tanstack/react-router'
import { ExperienceExtraction } from '@/features/admin/experience-extraction'

export const Route = createFileRoute(
  '/_authenticated/admin/experience-extraction'
)({
  component: ExperienceExtraction,
})
